import { defineStore } from 'pinia'
import { state, defaultMessageState, type MessageState } from './state'
import { getters } from './getters'

export const MODULE_NAME = 'messages'

// Idiomatic Pinia option store: getters are pure `(state) => value` functions
// (see ./getters), and former Vuex mutations are folded into `this`-based actions.
export const useMessagesStore = defineStore(MODULE_NAME, {
  state: (): MessageState => ({ ...state }),
  getters,
  actions: {
    setMessage(payload: MessageState) {
      this.show = payload.show
      this.typeOfMessage = payload.typeOfMessage
      this.title = payload.title
      this.msg = payload.msg
      this.action = payload.action
    },
    clearMessage() {
      this.action = defaultMessageState.action
      this.msg = defaultMessageState.msg
      this.show = defaultMessageState.show
      this.typeOfMessage = defaultMessageState.typeOfMessage
    },
  },
})

export { TypeOfMessage } from './state'
